import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import uploadImage from 'assets/images/sessions-upload.png'

const classes = {
  dropAreaWrapper: 'droparea-wrapper',
}

const Root = styled('section')(({ theme }) => ({
  [`.${classes.dropAreaWrapper}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '290px',
  },
}))

export default function DropArea() {
  return (
    <Root>
      <div className={classes.dropAreaWrapper}>
        <Box component="img" src={uploadImage} width={0.5} maxWidth="450px" />
      </div>
    </Root>
  )
}
